/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
// tslint:disable:no-any

/**
 * Encode and decode Crown data based on JSON format
 */
export class CrownProtocolJSON {
  constructor() {
    this._transform = (() => {
      const base64ToArrayBuffer = base64 => {
        const binaryString = atob(base64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);

        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }

        return bytes.buffer;
      }; // tslint:disable-next-line:no-any


      return (_key, val) => {
        if (val instanceof Object) {
          const cead = val;
          const isObject = cead.numOfElems !== undefined && cead.elemSz !== undefined && cead.endian !== undefined && cead.elemTypes !== undefined && cead.data !== undefined;

          if (isObject) {
            cead.data = new DataView(base64ToArrayBuffer(cead.data));
          }
        }

        return val;
      };
    })();
  }

  encode(data) {
    return JSON.stringify(data);
  }

  decode(data) {
    return JSON.parse(data, this._transform);
  }

}
//# sourceMappingURL=CrownProtocolJSON.js.map